// material-ui
import { useTheme } from '@mui/material/styles';

// project-imports
import { ThemeMode } from 'config';

// assets
import yoraLogo from 'assets/images/yora/yora-logo-tagline.svg';
import yoraLogoDark from 'assets/images/yora/yora-logo-tagline-dark.svg';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();

  return <img src={theme.palette.mode === ThemeMode.DARK ? yoraLogoDark : yoraLogo} alt="Yora" width="118" />;
}
